{
    "warning": "VAROITUS!",
    "message": "Älä anna tai liitä tähän koodia, jota et ymmärrä.\nTämän konsolin käyttäminen saattaa johtaa XSS-hyökkäykseen, jolloin hyökkääjät pystyvät esiintymään sinuna ja varastamaan tietosi."
}
